import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '.';

export interface IDiscountTypeModel extends IModel {
  discountTypeId: number;
  name: string;
  sortOrder: number;
}

export class DiscountTypeModel
  extends Model
  implements ModelRecord<IDiscountTypeModel>
{
  discountTypeId: number;
  name: string;
  sortOrder: number;

  constructor(params?: Partial<IDiscountTypeModel>) {
    super(params);
    this.discountTypeId = defaultTo(params?.discountTypeId, 0);
    this.name = defaultTo(params?.name, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
  }
}
